module.exports = __webpack_public_path__ + "static/media/plus.5937a27d.svg";